export const onGridReadyEvent = ({ onGridReady, params }) => {
  if (onGridReady) onGridReady(params);
};